export default [
  {
    value: "01",
    label: "990 - (all other) or 990EZ return",
  },
  {
    value: "02",
    label: "Required to file Form 990-N - Income less than $25,000 per year",
  },
  {
    value: "03",
    label: "Group return",
  },
  {
    value: "04",
    label: "Required to file Form 990-BL, Black Lung Trusts",
  },
  {
    value: "06",
    label: "Not required to file (church)",
  },
  {
    value: "07",
    label: "Government 501(c)(1)",
  },
  {
    value: "13",
    label: "Not required to file (religious organization)",
  },
  {
    value: "14",
    label:
      "Not required to file (instrumentalities of states or political subdivisions)",
  },
  {
    value: "00",
    label: "Not required to file (all other)",
  },
];
